export enum PageType {
	Assignee 			= 0b00000001,
	Vendor 	 			= 0b00000010,
	AssigneeOrVendor 	= 0b00000011,
	Customer			= 0b00000100,
	BoardMember 		= 0b00001000
}
